import { render, staticRenderFns } from "./OrderDiscountTitle.vue?vue&type=template&id=1c58e744&scoped=true&"
import script from "./OrderDiscountTitle.vue?vue&type=script&lang=js&"
export * from "./OrderDiscountTitle.vue?vue&type=script&lang=js&"
import style0 from "./OrderDiscountTitle.vue?vue&type=style&index=0&id=1c58e744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58e744",
  null
  
)

export default component.exports